import type { FormEvent } from 'react'

import { MaterialResult } from '@/components/material/MaterialResult'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'
import { Input } from '@/components/ui/Input'
import { useMaterialStore } from '@/store/material'

const EXAMPLES = [
  'Z41H-16C 闸阀',
  'Z41H-16C 闸阀 Φ159 碳钢',
  'Z41H-16C 闸阀 碳钢',
  'Z41H-16C 手动闸阀',
  'JMII 45*84',
  '6205 轴承',
  '6205-2Z/C3',
  'USA0805100MBK 气管 亚德客',
  'DS7X9-B2Q 联轴器',
]

export function ResultsPanel() {
  const text = useMaterialStore((s) => s.text)
  const status = useMaterialStore((s) => s.status)
  const error = useMaterialStore((s) => s.error)
  const data = useMaterialStore((s) => s.data)
  const setText = useMaterialStore((s) => s.setText)
  const run = useMaterialStore((s) => s.run)

  const submit = (event: FormEvent) => {
    event.preventDefault()
    void run()
  }

  return (
    <Card
      title="物料判定结果"
      subtitle="两层规则引擎：取料（找证据）→ 提炼（逐字段回链判定），无料如实报无法判定"
      className="h-full"
      bodyClassName="flex min-h-0 flex-col"
    >
      <form onSubmit={submit} className="shrink-0 border-b border-line p-3">
        <div className="flex gap-2">
          <Input
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="物料描述：型号 + 品名 + 已知参数，如 Z41H-16C 闸阀 DN150"
            className="h-9 flex-1 py-1"
            maxLength={500}
          />
          <Button type="submit" variant="primary" disabled={status === 'loading' || !text.trim()}>
            {status === 'loading' ? '判定中…' : '判定'}
          </Button>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {EXAMPLES.map((example) => (
            <button
              key={example}
              type="button"
              onClick={() => void run(example)}
              className="rounded-full border border-line bg-surface px-2.5 py-1 text-[11px] text-muted transition-colors hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700"
            >
              {example}
            </button>
          ))}
        </div>
      </form>

      {error && (
        <p className="shrink-0 border-b border-danger/25 bg-danger-soft px-3 py-2 text-[13px] text-danger">{error}</p>
      )}

      {status === 'loading' && !data ? (
        <div className="flex flex-1 items-center justify-center">
          <p className="text-xs text-muted">正在取料并逐字段判定…</p>
        </div>
      ) : data ? (
        <MaterialResult data={data} />
      ) : (
        <div className="min-h-0 flex-1">
          <EmptyState
            title="输入物料描述开始判定"
            hint="系统只按证据下结论：字段分八态（已核实/料已证/疑似/缺失/无法判定/冲突等），每条采用值都能回链到来源；料不够就阻断并告诉你补什么。"
          />
        </div>
      )}
    </Card>
  )
}
